import React, { useState, useEffect } from 'react';
import { useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import ResetPasswordPage from './components/ResetPasswordPage';
import TAdminPage from './pages/tAdmin/TAdminPage';
import KioskPage from './pages/visitor/KioskPage';
import BookingPage from './pages/BookingPage';
import ProspectKioskPage from './pages/ProspectKioskPage';
import FeedbackViewPage from './pages/FeedbackViewPage';

function App() {
  const { isAuthenticated } = useAuth();
  const [resetToken, setResetToken] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (window.location.pathname === '/reset-password' && token) {
      setResetToken(token);
    }
  }, []);

  // T-Admin is a completely separate self-contained app at /t-admin
  // It has its own login and does NOT require main app authentication
  if (window.location.pathname.startsWith('/t-admin')) {
    return <TAdminPage />;
  }

  if (resetToken) {
    return <ResetPasswordPage token={resetToken} onComplete={() => {
      setResetToken(null);
      window.history.replaceState({}, '', '/');
    }} />;
  }

  // Public booking page — no auth required
  if (window.location.pathname.startsWith('/book/')) {
    return <BookingPage />;
  }

  // Public prospect kiosk — no auth required
  if (window.location.pathname.startsWith('/prospect-kiosk/')) {
    return <ProspectKioskPage />;
  }

  // Visitor sign-in kiosk — no auth required
  if (window.location.pathname.startsWith('/visitor/')) {
    return <KioskPage />;
  }
  if (window.location.pathname.startsWith('/feedback/')) {
    return <FeedbackViewPage />;
  }

  return isAuthenticated ? <Dashboard /> : <Login />;
}

export default App;
